export var isMobile = function isMobile() {
  return window.innerWidth < 600;
};

export var getWindowSize = function getWindowSize() {
  var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0];

  var width = w.innerWidth || e.clientWidth || g.clientWidth;
  var height = w.innerHeight || e.clientHeight || g.clientHeight;

  return { width: width, height: height };
};
//# sourceMappingURL=device.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/device.js
// module id = 400
// module chunks = 0